import React from 'react'
import Slider from 'react-slick'

class ImageSlider extends React.Component {

  render() {
    const slider = this.props.data.map((item, index) =>
      <div className="inside-slider" key={index}>
        <div className="banner-image" style={{ backgroundImage: 'url("' +  item.url + '")' }} >
      </div></div>
    )
    console.log(this.props)
    var settings = {
      dots: true,
      arrows: false,
      infinite: true,
      speed: 200,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    };
    if (this.props.data.length > 0) {
      return (
        <Slider className="image-slider" {...settings}>
          {slider}
        </Slider>
      )
    }
    else {
      return ( null )
    }
  }
}
export default ImageSlider
